export default {
  "menu.home": "首頁",
  "menu.history": "歷史數據",
  "menu.deviceManagement": "設備管理",
  "menu.settings": "設置",
  "menu.messageCenter": "消息中心",
  "menu.help": "幫助與支持",
  "menu.mine": "我的",
};
